import styled from "@emotion/styled";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 20px;
  row-gap: 30px;
`;

export const EmailSentMessage = styled.p`
  font-size: 25px;
`;

export const LoginPageButton = styled.button`
  width: 250px;
  height: 50px;
  background-color: black;
  color: white;
  border-radius: 10px;
  font-size: 20px;
`;
